import styled from 'styled-components';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  NavLink
} from 'react-router-dom';
import { Colors, AxlModal } from 'axl-reactjs-ui';

export const Contain = styled.div`
  width: 100%;
  overflow: hidden;
  padding-bottom: 17px;
  &:hover {
    overflow-x: scroll;
  }
`;

export const Inner = styled.div`
  width: 1200px;
  margin: 0 auto;
  @media(min-width: 1200px) {
    width: 1440px;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

export const Main = styled.div`
  display: flex;
  margin: 20px -10px 0;
  min-height: 600px;
  height: calc(100vh - 211px);
`;

export const Title = styled.div`
  flex: 1;
  text-align: left;
  font-family: 'AvenirNext-Medium';
  font-size: 18px;
  font-weight: 500;
  color: #3b3b3b;
`;

export const Section = styled.div`
  flex: 1;
  padding: 0 10px;
  height: 100%;
`;
export const EmptyPanel = styled.div`
  flex: 2;
  padding: 0 10px;
`;
export const Empty = styled.div`
  margin-top: 30px;
`;

export const Panel = styled.div`
    border-radius: 5px;
    border: solid 1px ${Colors.veryLightPink};
    background-color: #f4f4f4;
    padding: 10px 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
`;

export const PanelDetail = styled(Panel)`
  padding: 0;
  background-color: #FFF;
  overflow: hidden;
`;

export const Text = styled.p`
  font-family: 'AvenirNext';
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  color: #000000;
  margin: 0;
`;

export const BackLink = styled(Link)`
  font-family: 'AvenirNext-Medium';
  font-size: 18px;
  font-weight: 500;
  color: #4a90e2;
  text-decoration: none;
`;

export const SectionMap = styled.div`
  border-radius: 5px;
  border: solid 1px #cfcfcf;
  height: 100%;
  overflow: hidden;
`;

export default {
  Modal: {
    borderRadius: 5
  }
}
